import { Flex } from "@redotech/arbiter/flex";
import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { RedoRadioGroup } from "@redotech/arbiter/radio/redo-radio-group";
import { Text } from "@redotech/arbiter/text";
import { LabeledInput, LabelSize } from "../../../labeled-input";

const LIMITED = "limited";
const UNLIMITED = "unlimited";

export function TotalUsesField({
  value,
  setValue,
  unlimited,
  setUnlimited,
  perCode,
}: {
  value: number | undefined;
  setValue: (value: number | undefined) => void;
  unlimited: boolean;
  setUnlimited: (value: boolean) => void;
  perCode: boolean;
}) {
  if (perCode) {
    return (
      <RedoTextInput
        description="Each code goes to one customer, so leaving this empty allows one use."
        fullWidth
        inputTypeHint="number"
        label="Uses per code"
        placeholder="1"
        setValue={(next) => setValue(next ? Number(next) : undefined)}
        value={value?.toString() ?? ""}
      />
    );
  }
  return (
    <LabeledInput
      label={
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Total number of uses
        </Text>
      }
      size={LabelSize.EXTRA_SMALL}
    >
      <Flex dir="column" gap="md">
        <RedoRadioGroup
          options={[
            { id: LIMITED, label: "Limit uses" },
            { id: UNLIMITED, label: "Unlimited" },
          ]}
          setValue={(next) => setUnlimited(next === UNLIMITED)}
          value={unlimited ? UNLIMITED : LIMITED}
        />
        {!unlimited && (
          <RedoTextInput
            fullWidth
            inputTypeHint="number"
            label="Number of uses"
            placeholder="1"
            setValue={(next) => setValue(next ? Number(next) : undefined)}
            value={value?.toString() ?? ""}
          />
        )}
      </Flex>
    </LabeledInput>
  );
}
